module.exports = __webpack_public_path__ + "static/media/shoesthatfit.456892b0.md";